import script from "./DaycareOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./DaycareOrders.vue?vue&type=script&setup=true&lang=js"

import "./DaycareOrders.vue?vue&type=style&index=0&id=66400b4e&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66400b4e"]])

export default __exports__